<template>
<div id="loginscreen">
    <h1 v-if="loading" class="h3 mb-3 font-weight-normal">Signing in...</h1>
    <form v-else class="form-signin">

   <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120">
       <text x="55" y="50" font-size="20" style="color:red">Open</text>
       <text x="5" y="95" font-size="55" font-weight="bolder">AS2</text>
   </svg> 
   
    
    <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>
    <label for="inputUsername" class="sr-only">Username</label>
    <input v-model="username" type="text" id="inputUsername" class="form-control" placeholder="Username" required="" autofocus="">
    <label for="inputPassword" class="sr-only">Password</label>
    <input v-model="password" type="password" id="inputPassword" class="form-control" placeholder="Password" required="">
    <label for="inputServer" class="sr-only">Server</label>
    <input v-model="server" type="text" id="inputServer" class="form-control" placeholder="Server" required="" autofocus="">
    <div class="checkbox mb-3">
        <label>
        <input type="checkbox" v-bind:checked="rememberme" value="remember-me"> Remember me
        </label>
    </div>
    <button class="btn btn-lg btn-primary btn-block" type="submit" v-on:click="login">Sign in</button>
    <div  v-if="errored" v-html="errormsg" class="alert alert-primary" role="alert"></div>
    <p class="mt-5 mb-3 text-muted">© 2017-2019</p>
    </form>
</div>
</template>
<script>
import { mapState } from 'vuex';
import store from '../store';
import axios from 'axios';

export default {
    name: 'login-screen',
    data: function() {return {
        username: '',
        password: '',
        // Runtime config (config.js) wins so one image can serve any deployment,
        // then the build-time value, then a local dev default.
        server: (window.__OPENAS2_CONFIG__ && window.__OPENAS2_CONFIG__.restApiUrl)
            || process.env.VUE_APP_RESTAPI_URL
            || 'http://127.0.0.1:8443/api',
        rememberme: false,
        loading: false,
        errormsg: '',
        errored: false
    }},
    methods: {
        login: function(e) {
            this.errormsg=null;
            this.errored = false;
            console.log(e);
            var credentials = btoa(`${this.username}:${this.password}`);
            var basicAuth = 'Basic ' + credentials;
            this.loading = true;
            axios
            .get(this.server +  '/',{ headers: { 'Authorization': basicAuth }})
            .then(response => {
                console.log("Login Response" ,response.data);
                if(response.data.type == 'OK') {
                  store.dispatch('loginAction',{ user: this.username, pass: this.password , server: this.server });
                }else{
                  this.errormsg=response.data.result;
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true;
                this.errormsg = error;
            })
            .finally(() => this.loading = false)
            
        }
    }
}
</script>
<style>
#loginscreen {
  min-height: calc(100vh - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at top, rgba(0, 174, 239, 0.12), transparent 38%),
    linear-gradient(180deg, #f3f7fb 0%, #edf3f8 100%);
  padding: 32px 16px;
}

.form-signin {
  width: 100%;
  max-width: 400px;
  padding: 32px 28px 24px;
  margin: auto;
  background: rgba(255, 255, 255, 0.93);
  border: 1px solid rgba(17, 24, 39, 0.06);
  border-radius: 18px;
  box-shadow: var(--shadow-soft);
  backdrop-filter: blur(2px);
}

.form-signin svg {
  display: block;
  margin: 0 auto 18px;
  filter: drop-shadow(0 10px 20px rgba(0, 174, 239, 0.12));
}

.form-signin h1 {
  margin-bottom: 22px !important;
  font-weight: 700;
  color: var(--primary-dark);
  letter-spacing: -0.02em;
}

.form-signin .checkbox {
  font-weight: 400;
  color: var(--text-secondary);
  margin: 14px 0 18px;
  text-align: left;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 12px 14px;
  font-size: 16px;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  background-color: #fff;
  color: var(--text-primary);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-signin .form-control:focus {
  z-index: 2;
  border-color: rgba(0, 174, 239, 0.55);
  box-shadow: 0 0 0 0.2rem rgba(0, 174, 239, 0.15);
}

.form-signin input + input,
.form-signin input + label,
.form-signin label + input {
  margin-top: 12px;
}

.form-signin .btn-primary {
  width: 100%;
  border-radius: 10px;
  padding: 12px 20px;
  font-weight: 600;
  letter-spacing: 0.02em;
  margin-top: 8px;
}

.form-signin .alert {
  margin-top: 16px;
  border-radius: 10px;
  border: 1px solid rgba(0, 174, 239, 0.2);
  background: rgba(0, 174, 239, 0.07);
  color: var(--text-primary);
}

.form-signin .text-muted {
  color: var(--text-secondary) !important;
  margin-top: 22px !important;
}
</style>
